<template>
    <div >
        <div class="page_header flex-around"><div ><i @click="$router.go(-1)" class="el-icon-back button-hover">&nbsp;返回</i></div><div><span class="color-blod1 ">当前位置：<span class="gonext">数据资源</span> —  </span><span class="color-blod2">{{stokeType}}</span></div></div>
    </div>
</template>
<script>
export default {
    data () {
        return {

        }
    },
    props:{
        stokeType:{
            type:String,
            data() {
                return ''
            },
        }
    },
    created() {
    },
    methods: {}
}
</script>

<style lang='scss' scoped>
    .el-icon-back{
        font-size: 20px;
        color: #002D72;
    }
    /deep/.el-page-header{
        position: relative;
    }
.page_header {
    width: 35%;
    padding-top: 100px;

    font-size: 0px;
}
.gonext:hover{
    cursor: pointer;
    opacity: 0.6;
}
.color-blod1{
    color: #271B63;
    font-size: 18px;
}
.color-blod2{
    color: #002D72;
    font-weight: bold;
}
</style>
